import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLoader } from '@moneymade/moneymade-ui'

import HeroBlock from './HeroBlock/HeroBlock'
import Team from './Team/Team'
import Investors from './Investors/Investors'

import styles from './AboutUsPage.module.scss'

const AboutUsPage = ({ aboutUs: { heroBlock, ourTeam, investors } }) => {
  const { loaderStatus, loaderElement, setLoader } = useLoader(false)

  useEffect(() => {
    if (heroBlock || ourTeam) setLoader(false)
  }, [heroBlock, ourTeam, setLoader])

  return !loaderStatus ? (
    <div className={styles.ContainerBanner} aria-hidden>
      {heroBlock?.title ? <HeroBlock banner={heroBlock} /> : null}
      {ourTeam ? <Team {...ourTeam} /> : null}
      {investors ? <Investors {...investors} /> : null}
    </div>
  ) : (
    <div className={styles.Loading}>{loaderElement}</div>
  )
}

AboutUsPage.propTypes = {
  aboutUs: PropTypes.shape({
    heroBlock: PropTypes.object,
    ourTeam: PropTypes.object,
    investors: PropTypes.object
  })
}

AboutUsPage.defaultProps = {
  aboutUs: PropTypes.shape({
    heroBlock: {},
    ourTeam: {},
    investors: {}
  })
}

export default AboutUsPage
